import React, { useState } from "react";
import { useNavigate } from "react-router";
import { AddUpdateFacilities } from "../../sub-modules";
import { CreateFacility } from "../../utilities/api/Facilities";
import { FacilityDetailType } from "../../utilities/types";
import { ToastContainer, toast } from "react-toastify";

const AddFacilities = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [facilityData, setFacilityData] = useState<FacilityDetailType>({
    name: "",
    isActive: "true",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "India",
    pincode: "",
    landmark: "",
    latitude: "",
    longitude: "",
  });
  const [submitButton, setSubmitButton] = useState(false);

  const handleCreateUpdate = async (payload: FacilityDetailType) => {
    setSubmitButton(true);
    const result = await CreateFacility(payload);
    if (result.status === 200) {
      navigate("/facilities");
    } else {
      setMessage(result.response.data.message);
      toast.error(result.response.data.message);
    }
    setSubmitButton(false);
  };

  return (
    <>
      <AddUpdateFacilities
        name="Add Facility"
        facilityData={facilityData}
        setFacilityData={setFacilityData}
        handleCreateUpdate={handleCreateUpdate}
        message={message}
        submitButton={submitButton}
      />
      <ToastContainer />
    </>
  );
};
export { AddFacilities };
